import React from "react";
import PropTypes from "prop-types";

import { withStyles } from "material-ui/styles";
import Typography from "material-ui/Typography";
import Button from "../../Parts/Button";

import DialogModal from "../../common/DialogModal";

const styles = () => ({
  text: {
    marginBottom: "40px",
    textAlign: "left",
  },

  button: {
    background: "#F03A47",
    "&:hover::before": {
      backgroundColor: "#F03A47",
      opacity: 0.6,
    },
  },

  contentContainer: {
    padding: "50px 40px",
    margin: 0,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    width: "450px",
    boxSizing: "border-box",
    background: "#FFFFFF",
  },

  buttonContainer: {
    display: "inline-flex",
    width: "100%",
    justifyContent: "space-evenly",
  },
});

class ConfirmCloseDialog extends React.Component {
  handleClick = () => {
    this.props.action();
    this.props.toggleDialog();
  };

  render() {
    const { classes, isOpen, toggleDialog} = this.props;

    let message = '編集中の権限があります。変更を破棄してこのページを離れますか？';
    let buttonText = '離れる';
    if (!this.props.isPageTransition) {
      message = '編集中の権限があります。変更を破棄しますか？';
      buttonText = '破棄する';
    }
    return (
      <DialogModal
        open={isOpen}
        onClose={toggleDialog}
        aria-labelledby="pop-up-window"
        maxWidth={false}
        classes={{
          contentContainer: classes.contentContainer,
        }}
      >
        <Typography variant="subheading" className={classes.text}>
          {message}
        </Typography>
        <div className={classes.buttonContainer}>
          <Button
            handleClickButton={toggleDialog}
            text="キャンセル"
            type="ghost"
          ></Button>
          <Button
            handleClickButton={this.handleClick}
            text={buttonText}
          ></Button>
        </div>
      </DialogModal>
    );
  }
}

ConfirmCloseDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  action: PropTypes.func.isRequired,
  toggleDialog: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  isPageTransition: PropTypes.bool,
};

PropTypes.defaultValue =  {
  isPageTransition: true, //ページ遷移するか
}

export default withStyles(styles)(ConfirmCloseDialog);



// WEBPACK FOOTER //
// ./src/components/AccountSetting/Basic/ConfirmCloseDialog.jsx